import "./polyfills";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import store from "app/redux/store";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";

// Import root app
import App from "app/containers/App";

// Inject font family and background from environment variables
const fontFamily =
  process.env.REACT_APP_FONT_FAMILY ||
  'SF Pro Display, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';
document.documentElement.style.setProperty("--font-family", fontFamily);

const loginBg =
  process.env.REACT_APP_BACKGROUND_COLOR ||
  "linear-gradient(135deg, #1B5E20 0%, #4AA02C 100%)";
document.documentElement.style.setProperty("--login-bg", loginBg);

const MOUNT_NODE = document.getElementById("root");
const root = ReactDOM.createRoot(MOUNT_NODE);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ToastContainer pauseOnFocusLoss={false} />
      <App />
    </BrowserRouter>
  </Provider>,
);
